var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1 mt-4",attrs:{"headers":_vm.headers,"items":_vm.usercaseList,"items-per-page":5,"sort-by":['ID']},scopedSlots:_vm._u([{key:"item.payment_status",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_c('span',{staticClass:"font-weight-bold text-uppercase text-no-wrap",style:({ color: value ? '#50bdc1' : '#b71c1c' }),domProps:{"textContent":_vm._s(value ? 'paid' : 'not paid')}})]}},{key:"item.status",fn:function(ref){
var value = ref.value;
return [_c('v-chip',[_vm._v(_vm._s(_vm.fStatus(value)))])]}},{key:"item.ID",fn:function(ref){
var value = ref.value;
return [_c('span',[_vm._v("SL-"+_vm._s(value))])]}},{key:"item.case_profile_type",fn:function(ref){
var value = ref.value;
return [_c('span',[_vm._v(_vm._s(_vm.fProfileType(value))+" licenсe")])]}},{key:"item.CreatedAt",fn:function(ref){
var value = ref.value;
return [_c('span',[_vm._v(_vm._s(_vm.fDate(value)))])]}},{key:"item.view",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_c('v-btn',{staticStyle:{"color":"#ffffff"},attrs:{"color":"#50bdc1"},on:{"click":function($event){return _vm.viewCase(item.ID)}}},[_vm._v("view")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }